<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Bounce Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="from_date"/> ~ <CustomDatePicker v-model="to_date"/></span>

				<em class="lt_text">Bounce Type</em>
				<span class="int_type_no_border mgr_5">
					<label>
						<select class="tbl_select full_int" v-model="bounce_type">
							<option value="">All</option>
							<option value="Bounced">Bounced</option>
							<option value="Stop Payment">Stop Payment</option>
							<option value="Bank Closed Account">Bank Closed Account</option>
						</select>
					</label>
				</span>

				<span class="int_type_no_border mgr_10" style="padding-top:3px;">
					<label class="mgr_10"><input type="radio" value="A" v-model="cleared" v-on:change="selectData()" /> All</label>
					<label class="mgr_10"><input type="radio" value="O" v-model="cleared" v-on:change="selectData()" /> Open</label>
					<label class="mgr_10"><input type="radio" value="C" v-model="cleared" v-on:change="selectData()" /> Cleared</label>
				</span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" />
				</span>

				<em class="lt_text">Keyword</em>
				<span class="int_type_no_border mgr_5">
					<input type="text" class="tbl_int ssm2_int" v-model.trim="receipt_dn" placeholder="Receipt No." />
				</span>

				<span class="int_type_no_border mgr_5">
					<input type="text" class="tbl_int ssm2_int" v-model.trim="invoice_dn" placeholder="invoice No." />
				</span>

				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<colgroup>
						<col style="width: 30px;" />
						<col style="width: 100px;" />
						<col style="width: 170px;" />
						<col style="width: 150px;" />
						<col style="width: 180px;" />
						<col style="width: 120px;" />
						<col />
						<col style="width: 70px;" />
						<col style="width: 90px;" />
						<col style="width: 140px;" />
						<col style="width: 110px;" />
						<col style="width: 80px;" />
						<col style="width: 80px;" />
						<col style="width: 150px;" />
					</colgroup>
					<thead>
						<tr>
							<th>No</th>
							<th>Bounce No</th>
							<th>Bounce Date</th>
							<th>Type Name</th>
							<th>General Remark</th>
							<th>
								<a href="javascript:void(0);" @click="sort('bill_to')">Bill To{{ sortMark('bill_to') }}</a>
							</th>
							<th>Bill To Name</th>
							<th>STATE</th>
							<th>Receipt Amt</th>
							<th>Sales Group</th>
							<th>Billing No</th>
							<th>Inv. Amt</th>
							<th>Inv. Balance</th>
							<th>Check No</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="type in root">
							<tr v-bind:key="type.code">
								<td colspan="14" class="al_left">{{ type.receipt_type_code }} {{ type.receipt_type_name }}</td>
							</tr>
							<template v-for="date in type.receiptTypeDateList">
								<template v-for="(bill, billIndex) in date.billList">
									<template v-for="(receiptItem, receiptItemIndex) in bill.receiptItemList">
										<tr v-for="(invoice, invoiceIndex) in receiptItem.invoiceList" :key="type.receipt_type_name + receiptItemIndex + date.receipt_no + invoice.invoice_no">
											<template v-if="billIndex === 0 && invoiceIndex === 0">
												<td class="al_right">{{ invoice.index }}</td>
												<td>{{ receiptItem.bounce_no }}</td>
												<td class="al_center">
													<CustomDatePicker v-model="receiptItem.bounce_date" />
													<button class="gray_bt2" @click="updateBounceDate(receiptItem)">UPD</button>
												</td>
											</template>
											<template v-else>
												<td></td>
												<td></td>
												<td></td>
											</template>
											<template v-if="invoiceIndex === 0">
												<td>{{ receiptItem.receipt_remark }}</td>
												<td class="al_left">
													<input type="text" class="tbl_int ssm2_int" v-model="receiptItem.general_remark" />
													<button class="gray_bt2" @click="updateGeneralRemark(receiptItem)">UPD</button>
												</td>
												<td class="al_left">{{ bill.bill_to_code }}</td>
												<td class="al_left">{{ bill.bill_to_name }}</td>
												<td class="al_center">{{ bill.bill_address_state }}</td>
												<td class="al_right">
													<span v-if="receiptItem.receipt_item_amount !== 0">{{ receiptItem.receipt_item_amount | toCurrency }}</span>
												</td>
												<td class="al_left">{{ bill.sales_group_name }}</td>
											</template>
											<template v-else>
												<td colspan="7"></td>
											</template>

											<td class="al_left">{{ invoice.invoice_dn }}</td>
											<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
											<td class="al_right">{{ invoice.invoice_balance | toCurrency }}</td>
											<td class="al_left">
												<span v-if="billIndex === 0 && invoiceIndex === 0">{{ receiptItem.check_no }}</span>
											</td>
										</tr>
									</template>
								</template>
							</template>
							<tr v-bind:key="type.code">
								<td colspan="8" class="al_right">Sub Total</td>
								<td class="al_right">{{ type.total_amount | toCurrency }}</td>
								<td colspan="5"></td>
							</tr>
						</template>
						<tr>
							<td colspan="8" class="al_right">Grand Total</td>
							<td class="al_right">{{ grandTotal | toCurrency }}</td>
							<td colspan="5"></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { apiIndex } from '@/api/report/report';
import CodeSelect from '@/components/common/CodeSelect';
import { apiGetReportTemplate, exportExcel, objectToFormData, Report, reportMrtUrl } from '@/api/util';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { today } from '@/utils/date';
import { apiBounceDate, apiBounceList } from '@/api/receipt';
import { apiUpdateGeneralRemarkOnly } from '@/api/sales/invoice';
export default {
	data: function() {
		return {
			root: [],
			sales_group_code: '',
			salesGroups: [],
			bill_to_code: '',
			receiptTypeList: '',
			receipt_type: '',
			sort_key: 'bill_to',
			sort_direction: 'ASC',
			from_date: today(),
			to_date: today(),
			bounce_type: '',
			cleared: 'A',

			receipt_dn: '',
			invoice_dn: '',
		};
	},
	components: {
		CodeSelect,
		PartnerSelect,
		CustomDatePicker,
	},
	methods: {
		async selectData() {
			let paramObj = null;
			if (!this.receipt_dn && !this.invoice_dn) {
				paramObj = {
					sales_group_code: this.sales_group_code,
					bill_to_code: this.bill_to_code,
					from_date: this.from_date,
					to_date: this.to_date,
					sort_key: this.sort_key,
					sort_direction: this.sort_direction,
					bounce_type: this.bounce_type,
				};
			} else {
				this.$toast.warning('Search by Receipt/Invoice No.');
				paramObj = {
					receipt_dn: this.receipt_dn,
					invoice_dn: this.invoice_dn,
				};
			}

			if (this.cleared != 'A') paramObj.cleared = this.cleared;

			const param = objectToFormData(paramObj);
			const { data } = await apiBounceList(param);
			this.root = data.value;
			this.dataNumber(this.root);
		},
		async index() {
			const { data } = await apiIndex('?salesGroup=true');
			this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
			//this.countries = data.countryList;
			//this.receiptTypeList = data.receiptTypeList;
		},
		async reportPrint() {
			this.root.type = 'print';
			const reportTemplate = await apiGetReportTemplate('BounceList', reportMrtUrl('BounceList'));
			const report = new Report(reportTemplate, this.root, 'BounceList');
			this.$store.commit('setReport', report);
		},
		setPartner(partner) {
			this.bill_to_code = partner.code;
		},
		reset() {
			this.from_date = today();
			this.to_date = today();
			this.bill_to_code = '';
			this.sales_group_code = '';
			this.bounce_type = '';
			this.cleared = 'A';
		},
		excel() {
			exportExcel('excelTable', 'ReceiptStatusByReceiptType');
		},
		sortMark: function(sort_key) {
			if (this.sort_key === sort_key) return this.sort_direction === 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectData();
			//console.log(sort_key);
		},
		dataNumber(list) {
			let index = 0;
			list.forEach(function(type) {
				type.receiptTypeDateList.forEach(function(date) {
					date.billList.forEach(function(bill, billIndex) {
						bill.receiptItemList.forEach(function(receipt) {
							receipt.invoiceList.forEach(function(invoice, invoiceIndex) {
								if (billIndex === 0 && invoiceIndex === 0) {
									index++;
									invoice.index = index;
								} else {
									invoice.index = undefined;
								}
							});
						});
					});
				});
			});
		},
		updateBounceDate(item) {
			const param = { date: item.bounce_date };
			apiBounceDate(item.receipt_item_no, param).then(response => {
				if (response.status === 200) this.$toast.success('Bounce Date has been changed.');
			});
		},
		updateGeneralRemark(item) {
			const param = { invoice_no: item.bounce_invoice_no, general_remark: item.general_remark };
			// console.log(param);
			// const dummy = true;
			// if (dummy) return;
			apiUpdateGeneralRemarkOnly(param).then(response => {
				if (response.status === 200) this.$toast.success('General remark has been updated.');
			});
		},
		parseQueryString() {
			const param = this.$route.query;
			if (param.receipt_dn) this.receipt_dn = param.receipt_dn;
			if (param.invoice_dn) this.invoice_dn = param.invoice_dn;

			if (this.receipt_dn || this.invoice_dn) this.selectData();
		},
	},
	computed: {
		grandTotal: function() {
			let total = 0;
			this.root.forEach(function(value) {
				total += value.total_amount;
			});
			return total;
		},
	},

	mounted() {
		this.$store.commit('setSideIndex', 5);
		this.$store.commit('setSelectedMenu', 'nav_li_bounceList');
		this.$store.commit('setSubTitle', 'Accounting -> Bounce List');

		this.parseQueryString();
		this.index();
	},
};
</script>

<style scoped></style>
